enum SignUpErrorCode {
  MISSING_EMAIL = "MISSING_EMAIL",
  INVALID_EMAIL = "INVALID_EMAIL",
}
const SignUpErrorMap: Record<SignUpErrorCode, string> = {
  [SignUpErrorCode.MISSING_EMAIL]: "Please enter an email in order to sign up.",
  [SignUpErrorCode.INVALID_EMAIL]: "Please double check the email you entered.",
};
export const getSignUpErrorMessage = (code?: string) => {
  if (code && code in SignUpErrorMap) {
    return SignUpErrorMap[code as SignUpErrorCode];
  }
  return "Something went wrong. Please contact us and we will resolve this issue ASAP.";
};
